






















































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import JobCorpsCenter from '@/classes/JobCorpsCenter';

@Component
export default class UserProfileView extends Vue {
    @Prop() public id!: string | number;

    get userProfile() {
        return this.$store.getters.getUserProfileById(this.id);
    }

    get jobCorpsCenters(): JobCorpsCenter[] {
        const arr: JobCorpsCenter[] = [];
        if (this.userProfile !== undefined) {
            this.userProfile.jobCorpsCenterIds.forEach((id: number) => {
                arr.push(this.$store.getters.getJobCorpsCenterById(id));
            });
        }
        return arr;
    }

    public getUserProfileName(id: number) {
        const user = this.$store.getters.getUserProfileById(id);
        if (user) {
            return user.getFullName();
        } else {
            return '';
        }
    }
}
